import {
  DIGITAL_PATH,
  LANDING_PAGE_PATH,
  LEAD_ORIGIN_URL,
  PARTNER_CAMP_ID,
  PARTNER_PATH,
  UTM_CAMPAIGN,
} from 'ppbl/utils/constants'
import { useEffect } from 'react'
import serverData from 'ppbl/utils/server-data'
import {
  storePartnerCampaignDetails,
  storeUtmCampaignDetails,
} from '../__utils__.js'
import { useExperiments } from 'ppbl/hooks'
import clientLogger from 'ppbl/utils/client-logger'
import { trackPage } from 'ppbl/utils/fpti-helper'

/**
 * This is a functional component that handles partner, digital, and BigC campaign redirection
 * @returns null
 */
function CampaignRedirectionPage() {
  clientLogger.info('New campaign redirection flow')

  const { ppbl_ui_newlook_experience = 'control' } = useExperiments()
  const isNewExperience = ppbl_ui_newlook_experience === 'treatment_1'

  const partnerCampaign = (partnerCampId) => {
    if (partnerCampId) {
      const campaignName =
        serverData?.data?.appConfig?.application?.campaignIdList?.[
          partnerCampId
        ] || ''
      return `CampaignRedirectionPage::${campaignName}`
    }
    return `CampaignRedirectionPage::`
  }

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search)
    const partnerCampId = queryParams.get(PARTNER_CAMP_ID)
    const utmCampaignId = queryParams.get(UTM_CAMPAIGN)
    const utmCampaignDetails = queryParams.toString()
    const leadOriginUrl = location.href
    sessionStorage.setItem(LEAD_ORIGIN_URL, leadOriginUrl)

    if (partnerCampId) {
      clientLogger.info(
        `User has come from Big C Campaign. partner_camp_id =${partnerCampId}`,
      )
      storePartnerCampaignDetails(partnerCampId)
    } else {
      storeUtmCampaignDetails(utmCampaignId, utmCampaignDetails)
    }

    const oldAppUrl = serverData.data.oldApplicationURI
    const page = partnerCampaign(partnerCampId)
    if (location.pathname?.includes(DIGITAL_PATH)) {
      //  digital flow
      if (!isNewExperience) {
        const logDetails = `User has come from DIGITAL Campaign and is redirected to OLD experience. leadOriginUrl=${leadOriginUrl}`
        clientLogger.info(logDetails)

        trackPage({ page, pageDetails: logDetails })

        window.location.replace(`${oldAppUrl}${DIGITAL_PATH}${location.search}`)
      } else {
        const logDetails = `User has come from DIGITAL Campaign and is redirected to NEW experience. leadOriginUrl=${leadOriginUrl}`
        clientLogger.info(logDetails)
        trackPage({ page, pageDetails: logDetails })

        window.location.replace(LANDING_PAGE_PATH)
      }
    } else if (!isNewExperience) {
      // partner flow
      const logDetails = `User has come from PARTNER Campaign and is in OLD experience. Redirected to ${oldAppUrl}${PARTNER_PATH}${location.search}. leadOriginUrl=${leadOriginUrl}`
      clientLogger.info(logDetails)
      trackPage({ page, pageDetails: logDetails })

      window.location.replace(`${oldAppUrl}${PARTNER_PATH}${location.search}`)
    } else {
      const logDetails = `User has come from PARTNER Campaign and is in NEW experience. Redirected to marketing page. leadOriginUrl=${leadOriginUrl}`
      clientLogger.info(logDetails)
      trackPage({ page, pageDetails: logDetails })

      window.location.replace(
        serverData.data.appConfig.application?.PPBLMarketingPage,
      )
    }
  }, [isNewExperience])

  return null
}

export default CampaignRedirectionPage
